
import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageTitleItem from "./common/ImageTitleItem"
import CardPanel from "./common/CardPanel"
import { useEffect } from "react"
import "./Technology.css"

const Technology = () => {

    useEffect(() => {
        document.title = 'Séneca - Tecnología'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="generic-main">

            <ImageTitleItem
                imageURL="/images/technology/tecnologia-1.jpg"
                imageURLMobile="/images/technology/tecnologia-1m.jpg"
                titleText="Conozca las últimas novedades"
                icon="bi bi-lightbulb blue-icon">
            </ImageTitleItem>
            <SliderImageSeparator />

            <CardPanel
                items={[
                    {
                        imageURL: "/images/technology/tecnologia-2.jpg",
                        src: "/seneca-volvera-a-estar-presente-en-el-cnis-2019/",
                        title: "Séneca volverá a estar presente en el CNIS 2019",
                        textArray: [
                            "<p className='technology-text'>La novena edición del Congreso Nacional de Innovación y Servicios Públicos (CNIS 2019), que se celebrará en la Fábrica Nacional de Moneda y Timbre Real Casa de la Moneda los próximos días 27 y 28 de febrero,  volverá a contar con la presencia de nuestro software Séneca como una de las herramientas fundamentales para la grabación […]</p>"
                        ]
                    },
                    {
                        imageURL: "/images/technology/tecnologia-3.jpg",
                        src: "/seneca-retransmite-congreso-cosital-2018-gijon/",
                        title: "Séneca retransmite el Congreso COSITAL 2018 celebrado en Gijón",
                        textArray: [
                            "<p className='technology-text'>La novena edición del Congreso Nacional de Innovación y Servicios Públicos (CNIS 2019), que se celebrará en la Fábrica Nacional de Moneda y Timbre Real Casa de la Moneda los próximos días 27 y 28 de febrero,  volverá a contar con la presencia de nuestro software Séneca como una de las herramientas fundamentales para la grabación […]</p>"
                        ]
                    }, {
                        imageURL: "/images/technology/tecnologia-4.jpg",
                        src: "/seneca-grabacion-plenos-y-realizacion-video-actas-cnis-2018/",
                        title: "Séneca, mejor solución de grabación de plenos y realización de video-actas en el CNIS 2018",
                        textArray: [
                            "<p className='technology-text'>La pasada semana estuvimos presentes en el VIII Congreso Nacional de Innovación y Servicios Públicos (CNIS 2018) celebrado en la Fábrica Nacional de Moneda y Timbre Real Casa de la Moneda. Nuestro software Séneca de video-actas y grabación de plenos fue uno de los protagonistas en unas jornadas que sirvieron para que los principales innovadores públicos […]</p>"
                        ]
                    }, {
                        imageURL: "/images/technology/tecnologia-5.jpg",
                        src: "/seneca-presente-en-el-i-congreso-red-localis/",
                        title: "Séneca patrocinará el I Congreso Red Localis",
                        textArray: [
                            "<p className='technology-text'>Spica sigue apostando por la transparencia y la innovación tecnológica en las administraciones a través de su software Séneca. Por ello, estaremos presentes como colaboradores en el I Congreso Red Localis, que se celebrará en el Centro Cultural Marcos Valcarcel (Ourense) los días 20 y 21 de junio de 2017, cuyo tema central será ‘Las […]</p>"
                        ]
                    }, {
                        imageURL: "/images/technology/tecnologia-6.jpg",
                        src: "/formacion-seneca/",
                        title: "Formación Séneca",
                        textArray: [
                            "<p className='technology-text'>Desde Séneca queremos ofrecer el más completo software de gestión de contenidos audiovisuales. Se trata de una herramienta para facilitar la comunicación entre las instituciones y el ciudadano, que posibilitan la transmisión, de manera directa y sin intermediarios, del mensaje, la postura y la coherencia de cada una de las ideas. 20 años trabajando […] </p>"
                        ]
                    }, {
                        imageURL: "/images/technology/tecnologia-7.jpg",
                        src: "/seneca-facilita-trabajo-secretarios-generando-video-actas/",
                        title: "Séneca facilita el trabajo a los Secretarios generando vídeo-actas",
                        textArray: [
                            "<p className='technology-text'>Séneca, un software creado expresamente para la gestión de contenidos audiovisuales en entornos institucionales, permite que los Secretarios puedan certificar el vídeo y vincularlo al acta. Así, el vídeo se transforma en un diario literal de sesiones: Séneca gestiona la autenticidad e integridad de la vídeo-acta con la firma del Secretario mediante certificado digital o […]</p>"
                        ]
                    },

                ]}

            />

        </main>
    )
}

export default Technology